module.exports = __webpack_public_path__ + "img/Home3.630280be.png";